import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/teacher-profiles', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/teacher-profiles', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/teacher-profiles/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
  return httpClient
    .put(`/api/teacher-profiles/${data.teacher_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/teacher-profiles/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const nationality = (Options = {}) => {
  return httpClient
    .get('/api/teacher-profiles/nationalities', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const activateType = (Options = {}) => {
  return httpClient
    .get('/api/teacher-profiles/register-types', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const mainProgram = (Options = {}) => {
  return httpClient
    .get(
      '/api/main-programs?fields[academic_program_mains]=acp_id,acp_name_foreign&page=-1',
      Options
    )
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const getMainProgram = (Option = {}) => {
  return httpClient
    .get('/api/teacher-profiles/fect-main-programs', Option)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const subProgram = (acp_id, Options = {}) => {
  return httpClient
    .get(`/api/teacher-profiles/fect-sub-program/${acp_id}`, Options)

    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const subject = (Options = {}) => {
  return httpClient
    .get(
      `/api/subject-cores?fields[academic_subjects]=acps_id,subject_id,subject_name_foreign,subject_code,subject_name_native&filter[acps_id]=${Options.acps_id}&page=-1&subject_type=1&is_appear_other_company=${Options.is_appear_other_company}`,
      Options
    )
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const province = (Options = {}) => {
  return httpClient
    .get('/api/teacher-profiles/provinces', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const district = (province_code, Options = {}) => {
  return httpClient
    .get(`/api/teacher-profiles/district/${province_code}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const commune = (district_code, Options = {}) => {
  return httpClient
    .get(`/api/teacher-profiles/commune/${district_code}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const village = (commune_code, Options = {}) => {
  return httpClient
    .get(`/api/teacher-profiles/village/${commune_code}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const uploadPhoto = data => {
  return httpClient
    .post('/api/teacher-profiles/photos', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const uploadSignatures = data => {
  return httpClient
    .post('/api/teacher-profiles/signatures', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const schedule = (teacher_id, Options = {}) => {
  return httpClient
    .get(`/api/teacher-profiles/schedules/${teacher_id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getShift = (Option = {}) => {
  return httpClient
    .get(
      '/api/attendance-shifts?page=-1&fields[attendance_shifts]=shift_id,shift_name,shift_type'
    )
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const position = (Options = {}) => {
  return httpClient
    .get('/api/teacher-profiles/positions')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const printCard = (Options = {}) => {
  return httpClient
    .get('/api/teacher-profiles/preview-cards', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const exportExcel = data => {
  return httpClient
    .post('/api/teacher-profiles/export-excel', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  find,
  store,
  update,
  destroy,
  nationality,
  activateType,
  mainProgram,
  subProgram,
  subject,
  province,
  district,
  commune,
  village,
  uploadPhoto,
  schedule,
  getShift,
  position,
  printCard,
  exportExcel,
  uploadSignatures,
  getMainProgram
}
